import React from 'react';
import styled from 'styled-components';
import { HudIcon, IconType } from '../Icons/HudIcons';
import HoverPopover from '../HoverPopover/HoverPopover';
import { transitionFunc } from '../theme/utils';
import { themeColor } from '../theme/colors';
import { PopoverProps } from '../Popover/Popover';

interface InfoPopoverProps extends PopoverProps {
  icon?: IconType;
  href?: string;
  stopPropagation?: boolean;
}

export function InfoPopover({
  body,
  icon = 'webviewMenu.info',
  href,
  stopPropagation = true,
  ...rest
}: InfoPopoverProps) {
  return (
    <HoverPopover body={body} position="top" width={220} {...rest}>
      {href ? (
        <ALink
          href={href}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => stopPropagation ?? e.stopPropagation()}
        >
          <HudIcon icon={icon} size="15px" />
        </ALink>
      ) : (
        <HudIcon icon={icon} size="15px" />
      )}
    </HoverPopover>
  );
}

const ALink = styled.a`
  line-height: 0;
  color: ${themeColor('textPrimary')};
  opacity: 0.6;
  z-index: 1;

  &:hover {
    opacity: 1;
    transition: opacity 0.3s ${transitionFunc};
  }
`;
